<div class="wrapper">
  <div class="container-fluid">

    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <!-- <li class="breadcrumb-item"><a href="javascript: void(0);">Home</a></li> -->
              <li class="breadcrumb-item active">Archived terminals</li>
            </ol>
          </div>
          <h4 class="page-title">Archived Terminals</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->


    <div class="row">
      <div class="col-12">

        <div class="card-box">
          <h4 class="header-title">Archived terminals</h4>
          <p class="sub-header">
            View archived terminals
          </p>

          <div class="row">
           
            
            <div class="col-12">
              <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped mb-0" style="width: 100%">
                <thead>
                  <tr>
                    <th>Merchant name</th>
                    <th>Merchant number</th>
                    <th>Terminal Id</th>
                    <th>Serial number</th>
                    <th>Sim number</th>
                    <th class="text-right">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let terminal of terminals">
                    <td>{{ terminal.merchantName}}</td>
                    <td>{{ terminal.merchantNumber}}</td>
                    <td>{{ terminal.terminalId}}</td>
                    <td>{{ terminal.serialNumber}}</td>
                    <td>{{ terminal.simNumber}}</td>
                    <td>
                      <!--<button type="button" class="btn btn-icon waves-effect waves-light btn-outline-primary fa-pull-right mx-2" (click)="editTerminal(terminal)">
                        <i class="mdi mdi-pencil-box-outline"></i>
                        View
                      </button> &nbsp;-->
                      <button type="button" class="btn btn-icon waves-effect waves-light btn-primary fa-pull-right mx-2" (click)="viewDeliveryNote(terminal)">
                        <i class="mdi mdi-pencil-box-outline"></i>
                        D.note
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>

      </div>

    </div>

  </div> <!-- end container -->
</div>
